import script from "./TimeframeTrend.vue?vue&type=script&lang=js"
export * from "./TimeframeTrend.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__